import request from '@/utils/request'

export function fetchList(query) {
    return request({
        url: '/admin/mealLevel/list',
        method: 'get',
        params: query
    })
}

export function batchSave(data) {
    return request({
        url: '/admin/mealLevel/batchSave',
        method: 'post',
        data
    })
}

export function batchUpdate(data) {
    return request({
        url: '/admin/mealLevel/batchUpdate',
        method: 'post',
        data
    })
}
